import PropTypes from 'prop-types'
import React from 'react'
import STSComponent from '../../STSComponent/STSComponent'
import { constants } from '../constants'

class StateBreakdown extends STSComponent {
  returnTitles = () => {
    const { field } = this.props
    return constants.stateBreakdown[field].map((item, i) => {
      return <div key={i} className="state-breakdown-col title">
        {item}
      </div>
    })
  }

  returnTable = () => {
    const { field } = this.props
    return stateData[field].map((item, i) => {
      const values = Object.values(item)
      return <div className="state-breakdown-table" key={i}>
        {values.map((elem, k) => {
          return <div key={k} className="state-breakdown-col">
            {elem}
          </div>
        })
        }
      </div>
    })
  }

  render () {
    const { title } = this.props
    return <div className="summary-tracking-wrapper">
      <div className="summary-tracking-title">{title}</div>
      <div className="state-breakdown-table">
        {this.returnTitles()}
      </div>
      {this.returnTable()}
    </div>
  }

  static propTypes = {
    field: PropTypes.string,
    title: PropTypes.string
  }
}

export default StateBreakdown

const stateData = {
  legis: [
    {
      state: 'Illinois',
      billsIntroduced: 0,
      billsEnacted: 0
    },
    {
      state: 'Alaska',
      billsIntroduced: 1,
      billsEnacted: 1
    },
    {
      state: 'Arizona',
      billsIntroduced: 0,
      billsEnacted: 0
    },
    {
      state: 'Washington',
      billsIntroduced: 1,
      billsEnacted: 1
    }
  ],
  regs: [
    {
      state: 'Oregon',
      approved: 0,
      total: 1
    }
  ],
  local: [
    {
      state: 'Oregon',
      approved: 0,
      total: 1
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/components/StateBreakdown.js